export default "__VITE_ASSET__70HH7vNs__"